import type {
    DepositAccount,
    PaymentDate,
    RecurringDetailsRequestDTO,
} from '@fruitful/types';

import type { Cents } from '../../../common/types/Common';
import { requestBuilder } from '../../../http/RequestBuilder';

export interface PaymentScheduleRenderDetails extends RecurringDetailsRequestDTO {
    fromAccount: DepositAccount;
    toAccount: DepositAccount;
    amount: Cents;
    id: string;
    nextPaymentDate?: PaymentDate;
    metadata?: {
        applyIncomeSplit?: boolean;
    };
}

const useGetPaymentSchedules = requestBuilder.query<
    PaymentScheduleRenderDetails[],
    { syncteraPersonId: string }
>({
    endpoint: ({ syncteraPersonId }) =>
        `/api/admin/banking/payment-schedule/${syncteraPersonId}`,
    queryKey: ({ syncteraPersonId }) =>
        `getPaymentSchedules/${syncteraPersonId}`,
});

export default useGetPaymentSchedules;
